import "./exportCsv.scss";

import PropTypes from "prop-types";
import PubSub from "pubsub-js";
import React, { Fragment, PureComponent } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import { connect } from "react-redux";

import FormButton from "../../components/form/FormButton";
import FormCheckbox from "../../components/form/FormCheckbox";
import FormRadio from "../../components/form/FormRadio";
import ModalBody from "../../components/modal/ModalBody";
import ModalCheckboxGrid from "../../components/modal/ModalCheckboxGrid";
import ModalField from "../../components/modal/ModalField";
import ModalFooter from "../../components/modal/ModalFooter";
import ModalFooterRightGroup from "../../components/modal/ModalFooterRightGroup";
import ModalHeading from "../../components/modal/ModalHeading";
import ModalRow from "../../components/modal/ModalRow";
import ModalView from "../../components/modal/ModalView";
import { CSV_DELIMITER } from "../../constants/importExportFile";
import PubSubTopics from "../../constants/pubSubTopics";
import { typeSelectors } from "../../modules/definition/types";
import { uiStateOperations } from "../../modules/uiState";
import { nativeCommsBroadcastMessageTypes } from "../../nativeComms";
import { exportCsvFile } from "../../nativeComms/nativeCommsReceiver.shared";
import { listToMap } from "../../utils/immutableExtensions";

class ExportCsvModal extends PureComponent {
  constructor(props) {
    super(props);

    this.onExport = this.onExport.bind(this);

    this.state = {
      delimiter: CSV_DELIMITER.COMMA,
      typesCheck: listToMap(props.itemTypes).map(_t => true),
      selectedItemsOnly: false
    };
  }

  componentDidMount() {
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.EXPORT_CSV_OPENED
    });
    this._pubSubEscapeKeyDownToken = PubSub.subscribe(PubSubTopics.escapeKeyDown, this.props.onCloseClick);
  }

  componentWillUnmount() {
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.EXPORT_CSV_CLOSED
    });
    PubSub.unsubscribe(this._pubSubEscapeKeyDownToken);
  }

  getItemTypeCheckBoxes() {
    const { typesCheck } = this.state;
    return this.props.itemTypes.map(t => (
      <FormCheckbox
        key={t.id}
        checkboxState={typesCheck.get(t.id)}
        label={t.label}
        onChange={newState => this.setState({ typesCheck: typesCheck.set(t.id, newState) })}
      />
    ));
  }

  onExport() {
    const { delimiter, typesCheck, selectedItemsOnly } = this.state;
    const { itemTypes } = this.props;
    this.props.onExportClick(
      delimiter,
      itemTypes.filter(t => typesCheck.get(t.id)).map(t => t.id),
      selectedItemsOnly
    );
  }

  render() {
    const { delimiter, selectedItemsOnly } = this.state;

    const modalHeading = (
      <ModalHeading title="Export to CSV" showCancel={true} onCancelClick={this.props.onCloseClick} showDone={true} />
    );
    const modalFooter = (
      <ModalFooter>
        <ModalFooterRightGroup>
          <FormButton primary={true} label={`Export`} onClick={this.onExport} />
        </ModalFooterRightGroup>
      </ModalFooter>
    );

    const bodyContent = (
      <Fragment>
        <ModalRow>
          <ModalField label="Delimiter">
            <ModalCheckboxGrid columns={3}>
              <FormRadio
                key={CSV_DELIMITER.COMMA}
                label="Comma"
                isChecked={delimiter === CSV_DELIMITER.COMMA}
                onChange={() => this.setState({ delimiter: CSV_DELIMITER.COMM })}
              />
              <FormRadio
                key={CSV_DELIMITER.TAB}
                label="Tab"
                isChecked={delimiter === CSV_DELIMITER.TAB}
                onChange={() => this.setState({ delimiter: CSV_DELIMITER.TAB })}
              />
            </ModalCheckboxGrid>
          </ModalField>
        </ModalRow>
        <ModalRow>
          <ModalField label="Items Types to Export">
            <ModalCheckboxGrid columns={5}>{this.getItemTypeCheckBoxes()}</ModalCheckboxGrid>
          </ModalField>
        </ModalRow>
        <ModalRow>
          <ModalField>
            <FormCheckbox
              label="Selected items only"
              checkboxState={selectedItemsOnly}
              onChange={newState => this.setState({ selectedItemsOnly: newState })}
            />
          </ModalField>
        </ModalRow>
      </Fragment>
    );

    return (
      <ModalView header={modalHeading} footer={modalFooter} fixedHeight={null}>
        <ModalBody>{bodyContent}</ModalBody>
      </ModalView>
    );
  }
}

ExportCsvModal.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
  onExportClick: PropTypes.func.isRequired,
  itemTypes: ImmutablePropTypes.list.isRequired
};

const mapStateToProps = state => {
  return {
    itemTypes: typeSelectors.getOrderedTypes(state.present)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onCloseClick: () => {
      dispatch(uiStateOperations.hideExportCsvModal());
    },
    onExportClick: (delimiter, typesId, isSelectedItemsOnly) => {
      exportCsvFile(delimiter, typesId, isSelectedItemsOnly);
      dispatch(uiStateOperations.hideExportCsvModal());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExportCsvModal);
